import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import {
    Paper,
    FormControl,
    TextField,
    Select,
    MenuItem,
    Typography,
    FormGroup,
    Checkbox,
    FormControlLabel
} from '@material-ui/core';
import axios from 'axios';
import Common from '../../Common';
import SearchButton from './ChatUserSearchButton';
import ResetButton from './ChatUserResetButton';

const styles = () => ({
    paper: {
        width: '95%',
        marginTop: '5px',
    },
    conditionLeft: {
        width: '300px',
    },
    addressConditionLeft: {
        width: '300px',
        marginLeft: '30px'
    },
    categoryChatList: {
        width: '400px',
        marginBottom: '30px'
    },
    title:{
        marginTop: '30px'
    },
    inputKeyword:{
        fontSize: '20px',
        justifyContent:'center',
        alignItems: 'center',
        margin: '10px 0px 10px 0px',
    },
    selectKubunArea: {
        marginTop:'50px',
    },
    buttonArea:{
        //marginTop:'20px',
        marginLeft: '50px',
        marginBottom:'20px'
    },
    nickNameArea:{
        marginTop:'20px',
        marginBottom:'50px'
    },
    deletionFlgList:{
        borderBottom: 'solid 2px #FFF',
        height:'40px',
    },
    keyword:{
        left: '30px',
        //marginLeft: '1px',
        width: 315
    },
    left:{
        display: 'inline-block',
    },
    inputAddress:{
        margin: '30px 0px 0px 0px',
        marginLeft: '100px',
    },
    keywordArea:{
        margin: '30px 0px 0px 75px',
    },
    marginLeft:{
        marginLeft: '10px'
    },
    checkbox:{
        margin: '30px 0px 0px 240px',
    }
});

const SettingUserSearch = withCookies((props) => {
    const { classes, setData, cookies, setAllUpdate, setIsLoading, selectedKubunId, setSelectedKubunId, setSelectedKubunName} = props;
    const [categoryChatList, setCategoryChatList] = React.useState([]);
    const [displayChatName, setDisplayChatName] = React.useState('---選択してください---');
    const [address, setAddress] = React.useState('');
    const [keyword, setKeyword] = React.useState('');
    const [includeNotPaticipateFlg, setIncludeNotPaticipateFlg] = React.useState(false);
    const [includeUserInChat, setIncludeUserInChat] = React.useState(false);
    const chatNameObj = cookies.get('COMMON_NAME_OBJ');
    const kubunName = chatNameObj !== undefined ? chatNameObj.KUBUN_NAME : 'チャットカテゴリ';
    const addressName = chatNameObj !== undefined ? chatNameObj.ADDRESS_NAME : '宛名番号';
    const userName = chatNameObj !== undefined ? chatNameObj.USER_NAME : 'ニックネーム';
    const participateName = chatNameObj !== undefined ? chatNameObj.PARTICIPATE_NAME : '連携';
    const inchatName = chatNameObj !== undefined ? chatNameObj.INCHAT_NAME : 'チャット';

    //-----------------------------------------------------------------
    //              ページに格納するデータの取得
    //-----------------------------------------------------------------
    function getChatData() {
        if(categoryChatList.length === 0){
            //TOKEN取得
            axios.post(
                `${Common.apiServerUrl()}/api/auth/token`,
                {},
                {
                    headers: {
                        'Authorization': 'Bearer ' + cookies.get('id_token')
                    },
                }
            )
            .then(Common.handleErrors)
            .then((Response) => {
                if (Response.success) {
                    cookies.set('token', Response.token, {
                        maxAge: 60 * 60 * 24 * 30, //30日間
                        httpOnly: false,
                        path: '/',
                        secure: true,
                    });

                    const jichitaiToken = cookies.get('x-jichitai-token');
                    const jichitaiId = cookies.get('x-jichitai-jichitaiid');
                    const supportedPersonId = cookies.get('supportedPersonId');

                    //-------------------------------------------
                    //プルダウンに表示する情報区分の取得 APIアクセス先(johoKubun.js)
                    //cookieに保存している職員番号でGetアクセスを行う
                    //-------------------------------------------
                    // -------------------------axios------------------------------
                    axios.get(
                        `${Common.apiServerUrl()}/api/counseling/getResponsibleKubun`,
                        {
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                                'x-suppportcenter-token': Response.token,
                                'x-jichitai-jichitaiid': jichitaiId,
                                'x-jichitai-token': jichitaiToken,
                            },
                            params: {
                                supportedPersonId
                            }
                        }
                    )
                    .then(Common.handleErrors)
                    .then((response) => {
                        const res = response.getResponsibleKubunArray;
                        if (response.success) {
                            if (res.length === 0) {
                                return;
                            } else {
                                const categoryList = [];
                                res.map((d) => {
                                    if(d.counselingKubunId !== '00' && d.counselingKubunId !== 'all'){
                                        const resObj = {
                                            categoryName: d.counselingKubunName,
                                            categoryId: d.counselingKubunId
                                        };
                                        categoryList.push(resObj);
                                    }
                                });
                                setCategoryChatList(categoryList);
                            }
                        } else {
                            window.alert(`code : [${response.type}]\nmessage : ${response.message}`);
                        }
                    })
                    .catch((err) => {
                        console.error('ChatUserSearch.js :get err:' + err.message);
                    });
                }
            })
            .catch((err) => {
                console.error('ChatUserSearch.js :get err:' + err.message);
            })
        }
    }

    function handleChatChange(categoryId){
        if(categoryId !== '' ){
            setSelectedKubunId(categoryId);
            //setAllUpdate(false);
            setIsLoading(true);
            const selectChat = categoryChatList.filter((d) => d.categoryId === categoryId);
            setDisplayChatName(selectChat[0].categoryName);
            setSelectedKubunName(selectChat[0].categoryName);
            //検索条件のリセット
            setAddress('');
            setKeyword('');
            setIncludeNotPaticipateFlg(false);
            setIncludeUserInChat(false);
            //検索条件なしで検索
            axios.post(
                `${Common.apiServerUrl()}/api/search`,
                {
                    chatId: categoryId,
                    keyword: '',
                    address: '',
                    includeNotPaticipateFlg: false,
                    includeUserInChat: false
                },
                {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + cookies.get('access_token'),
                        'x-suppportcenter-token': cookies.get('token'),
                        'x-jichitai-jichitaiid': cookies.get('x-jichitai-jichitaiid'),
                        'x-jichitai-token': cookies.get('x-jichitai-token'),
                    },
                    data: {},
                }
            )
            .then(Common.handleErrors)
            .then((res) => {
                if (res.success) {
                    if(res.result.length === 0) window.alert('絞り込み条件に合致する結果が⾒つかりませんでした。');
                    setData(res.result);
                } else {
                    window.alert(`code : [${res.type}]\nmessage : ${res.message}`);
                }
            })
            .catch((err) => {
                console.error('ChatUserSearchButton.js setUserDatas:get err:' + err.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
        }
        else{
            setSelectedKubunId('');
            setDisplayChatName('---選択してください---');
            setData([]);
            setSelectedKubunName('選択なし');
        }
    }

    useEffect(() => {
        if(categoryChatList.length === 0) getChatData();
    },[]);

    return (
        <React.Fragment>
            <FormGroup className={classes.selectKubunArea} row>
                <Typography variant="body1" className={classes.inputKeyword}>
                    {`${kubunName}：`}
                </Typography>
                <FormControl className={classes.keyword}>
                    {/* */}
                    <Select
                        id="multiple-checkbox-johoKubun"
                        value={displayChatName}
                        className={classes.categoryChatList}
                        variant="outlined"
                    >
                        <MenuItem key={0} value={'---選択してください---'} className={classes.deletionFlgList} onClick={() => handleChatChange('')}>{'---選択してください---'}</MenuItem>
                        {categoryChatList.map((rec, i) => (
                            <MenuItem key={i+1} value={rec.categoryName} onClick={() => handleChatChange(rec.categoryId)} className={classes.deletionFlgList}>
                                {`${rec.categoryName}`}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </FormGroup>
            <Typography className={classes.title} variant="h6" component="p">
                絞り込み条件設定
            </Typography>
            <Paper elevation={2} variant="outlined" className={classes.paper}>
                <div className={classes.left}>
                    <FormGroup className={classes.nickNameArea} row>
                        <Typography variant="body1" className={classes.inputAddress}>
                            {`${addressName}：`}
                        </Typography>
                        <FormControl className={classes.keyword}>
                            <TextField
                                id="outlined-basic"
                                variant="outlined"
                                className={classes.addressConditionLeft}
                                margin="normal"
                                value={address}
                                onChange={(event) => setAddress(event.target.value)} />
                        </FormControl>
                        <Typography variant="body1" className={classes.keywordArea}>
                            {`${userName}：`}
                        </Typography>
                        <FormControl className={classes.keyword}>
                            <TextField
                                id="outlined-basic"
                                variant="outlined"
                                className={classes.conditionLeft}
                                margin="normal"
                                value={keyword}
                                onChange={(event) => setKeyword(event.target.value)} />
                        </FormControl>
                        <FormGroup className={classes.checkbox} row>
                            <FormControlLabel
                                control={<Checkbox checked={includeNotPaticipateFlg} onChange={(event) => setIncludeNotPaticipateFlg(event.target.checked)} />}
                                label={<Typography variant="body2">{`未${participateName}のユーザーを含む`}</Typography>} />
                            <FormControlLabel
                                className={classes.marginLeft}
                                control={<Checkbox checked={includeUserInChat} onChange={(event) => setIncludeUserInChat(event.target.checked)} />}
                                label={<Typography variant="body2">{`${inchatName}中のユーザーを含む`}</Typography>} />
                        </FormGroup>
                    </FormGroup>
                    <FormGroup className={classes.buttonArea} row>
                        <FormGroup className={classes.buttonArea} row>
                            <SearchButton
                                chatId={selectedKubunId}
                                setData={setData}
                                address={address}
                                keyword={keyword}
                                includeNotPaticipateFlg={includeNotPaticipateFlg}
                                includeUserInChat={includeUserInChat}
                                setAllUpdate={setAllUpdate}
                                setIsLoading={setIsLoading}
                            />
                            <ResetButton
                                setData={setData}
                                setAddress={setAddress}
                                setKeyword={setKeyword}
                                setIncludeNotPaticipateFlg={setIncludeNotPaticipateFlg}
                                setIncludeUserInChat={setIncludeUserInChat}
                            />
                        </FormGroup>
                    </FormGroup>
                </div>
            </Paper>
        </React.Fragment>
    );
});

SettingUserSearch.propTypes = {
    classes: PropTypes.object.isRequired,
    setData: PropTypes.func.isRequired,
    cookies: PropTypes.object.isRequired,
};


export default withStyles(styles)(SettingUserSearch);